<div class="inline-flex max-w-full items-center gap-3 text-sm text-gray-800">
  <button
    [id]="id()"
    type="button"
    role="switch"
    [disabled]="disabled()"
    [attr.aria-checked]="checked()"
    [attr.aria-label]="label() || 'Schalter'"
    (click)="toggle()"
    (blur)="markAsTouched()"
    (keydown.space)="toggleWithKeyboard($event)"
    (keydown.enter)="toggleWithKeyboard($event)"
    class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors outline-none focus:ring-2 focus:ring-green-800 focus:ring-offset-2"
    [ngClass]="
      disabled()
        ? 'cursor-not-allowed border-gray-200 bg-gray-200 opacity-70'
        : checked()
          ? 'border-green-800 bg-green-800'
          : 'border-gray-300 bg-gray-300'
    ">
    <span
      aria-hidden="true"
      class="inline-block size-5 rounded-full bg-white shadow-sm transition-transform"
      [ngClass]="checked() ? 'translate-x-5' : 'translate-x-0.5'"></span>
  </button>

  @if (label()) {
    <button class="min-w-0 cursor-pointer leading-5" (click)="toggle()">{{ label() }}</button>
  }
</div>
